/**
 * Intelligems A/B — GBP gallery image fallback ($39 → £39)
 *
 * Primary swap is server-side via snippets/comfofeet-uk-bundle-media.liquid.
 * This script is a lightweight fallback only when Liquid did not swap.
 *
 * Variant (en-gb only):
 *   document.body.setAttribute('data-gbp-gallery-image', 'true');
 *
 * Dev preview (en-gb only): ?gbp_gallery_image=true
 *
 * Set window.__comfofeetUkBundleGbpSrc from Liquid before this script loads.
 */
(function () {
  'use strict';

  if (window.__comfofeetUkBundleImageInit) return;
  window.__comfofeetUkBundleImageInit = true;

  var ATTR = 'data-gbp-gallery-image';
  var MATCH = 'Comfo_high_quality_1';
  var GBP_MARK = 'Group_1000014928';
  var bodyObserver = null;
  var swapping = false;
  var finished = false;

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return (
      normalized === 'true' ||
      normalized === '1' ||
      normalized === 'on' ||
      normalized === 'yes'
    );
  }

  function isEnGb() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang === 'en-gb') return true;

    var segments = (window.location.pathname || '')
      .toLowerCase()
      .split('/')
      .filter(Boolean);
    return segments.indexOf('en-gb') !== -1;
  }

  function getDevEnabled() {
    try {
      return isTruthy(
        new URLSearchParams(window.location.search).get('gbp_gallery_image')
      );
    } catch (e) {
      return false;
    }
  }

  function liquidAlreadySwapped() {
    if (document.querySelector('[data-uk-bundle-gbp="1"]')) return true;

    var imgs = document.querySelectorAll('img[src*="' + GBP_MARK + '"]');
    return imgs.length > 0;
  }

  function isEnabled() {
    if (!isEnGb() || !document.body || finished || liquidAlreadySwapped()) {
      return false;
    }
    if (getDevEnabled()) return true;
    return isTruthy(document.body.getAttribute(ATTR));
  }

  function gbpSrc() {
    return window.__comfofeetUkBundleGbpSrc || '';
  }

  function shouldSwap(img) {
    if (!img || img.nodeType !== 1) return false;
    if (img.getAttribute('data-uk-bundle-gbp') === '1') return false;
    if (img.getAttribute('data-uk-bundle-swapped') === '1') return false;

    var src = img.currentSrc || img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset') || '';
    var dataSrc = img.getAttribute('data-src') || '';
    var dataSrcset = img.getAttribute('data-srcset') || '';

    if (src.indexOf(GBP_MARK) !== -1 || srcset.indexOf(GBP_MARK) !== -1) {
      return false;
    }

    return (
      src.indexOf(MATCH) !== -1 ||
      srcset.indexOf(MATCH) !== -1 ||
      dataSrc.indexOf(MATCH) !== -1 ||
      dataSrcset.indexOf(MATCH) !== -1
    );
  }

  function swapImg(img) {
    var src = gbpSrc();
    if (!src || !shouldSwap(img)) return false;

    img.setAttribute('src', src);
    img.removeAttribute('srcset');
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', src);
    if (img.hasAttribute('data-srcset')) img.removeAttribute('data-srcset');
    img.setAttribute('data-uk-bundle-swapped', '1');
    return true;
  }

  function teardown() {
    finished = true;
    if (bodyObserver) {
      bodyObserver.disconnect();
      bodyObserver = null;
    }
  }

  function run() {
    if (swapping || !isEnabled() || !gbpSrc()) return false;

    swapping = true;
    var didSwap = false;
    try {
      document.querySelectorAll('img').forEach(function (img) {
        if (swapImg(img)) didSwap = true;
      });
    } finally {
      swapping = false;
    }

    if (didSwap || liquidAlreadySwapped()) {
      teardown();
    }

    return didSwap;
  }

  function watchBodyOnce() {
    if (!document.body || typeof MutationObserver === 'undefined' || bodyObserver) {
      return;
    }

    bodyObserver = new MutationObserver(function (mutations) {
      if (finished || liquidAlreadySwapped()) {
        teardown();
        return;
      }

      var i;
      for (i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === ATTR && isEnabled()) {
          run();
          teardown();
          return;
        }
      }
    });

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR],
    });
  }

  function boot() {
    if (!isEnGb()) {
      window.ComfofeetUkBundleImage = {
        attr: ATTR,
        isEnGb: false,
        isEnabled: isEnabled,
        run: run,
      };
      return;
    }

    if (liquidAlreadySwapped()) {
      teardown();
      window.ComfofeetUkBundleImage = {
        attr: ATTR,
        isEnGb: isEnGb,
        isEnabled: isEnabled,
        run: run,
        liquidHandled: true,
      };
      return;
    }

    if (isEnabled()) {
      run();
    }

    if (!finished && (isEnabled() || getDevEnabled())) {
      watchBodyOnce();
    }

    if (!finished && isEnabled()) {
      window.setTimeout(function () {
        if (!finished) run();
      }, 500);
    }

    window.ComfofeetUkBundleImage = {
      attr: ATTR,
      isEnGb: isEnGb,
      isEnabled: isEnabled,
      run: run,
      liquidHandled: false,
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
